<h2 mat-dialog-title class="report-dialog-title"><mat-icon>sensors</mat-icon>Sensor readings</h2>
<div mat-dialog-content>
  <p class="report-dialog-description">Readings from {{ readings[2] }} on {{ readings[1] }}</p>
  @for (reading of readings[0]; track reading; let i = $index) {
    <section class="report-reading-card">
      <div class="report-reading-heading"><h3>{{ reading.Name }}</h3><span class="report-reading-value">{{ reading.Value }} {{ reading.Unit }}</span></div>
      <dl class="report-detail-list">
        <div><dt>Code</dt><dd>{{ reading.Code }}</dd></div>
        <div><dt>Trend</dt><dd>{{ reading.Trend }}</dd></div>
        <div><dt>Unit</dt><dd>{{ reading.Unit }}</dd></div>
      </dl>
    </section>
  } @empty { <p class="report-dialog-empty">No readings are available for this record.</p> }
</div>
<div mat-dialog-actions class="report-dialog-actions">
  <button mat-flat-button class="report-dialog-primary" [mat-dialog-close]="true" cdkFocusInitial>Close</button>
</div>
